import {MonthWithIndex} from "../../../services/api/insight-api"

const monthNames = ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"]

export function getMonthHeaderWithYear(m: MonthWithIndex) {
  if (m == null) return ""
  var monthDate = new Date(m.month)
  return `${getMonthHeader(m)} ${monthDate.getFullYear()}`
}

export function getMonthHeader(m: MonthWithIndex) {
  if (m == null) return ""
  var monthDate = new Date(m.month)
  return `${monthNames[monthDate.getMonth()]}`
}

export function getMonthHeaderWithYearForDate(date: Date) {
  return `${getMonthName(date)} ${date.getFullYear()}`
}

export function getMonthName(date: Date) {
  return monthNames[date.getMonth()]
}